import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddRole from '@rsos/components/capstone/RolesShared/AddRole';
import { MAX_ROLES_COUNT } from '@rsos/components/capstone/RolesShared/utils/constants';
import {
  fetchAppRoles,
  selectUserOrgByApp,
  selectManagementByApp,
} from '@rsos/sinatra';
import Roles from './Roles';
import {
  AddRoleWrapper,
  RolesHeader,
  Description,
} from './RolesManagement.styles';

const RolesManagement = () => {
  const dispatch = useDispatch();
  const sinatra = useSelector(state => state.sinatra);
  const { application } = sinatra.user.currentRole;
  const org = selectUserOrgByApp(sinatra, application);
  const management = selectManagementByApp(sinatra, org.id, application);

  const allRoles = management?.roles?.records || [];
  const allPermissions = management?.permissions?.records || [];
  const isMaxRolesCountReached = allRoles.length >= MAX_ROLES_COUNT;

  useEffect(() => {
    dispatch(fetchAppRoles(org.id, application));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <RolesHeader>Roles & Access</RolesHeader>
      <Description>
        You can manage your roles and change access permissions for each role
        here. This includes access to RapidSOS features and data sources.{' '}
      </Description>
      <AddRoleWrapper>
        <AddRole
          roles={allRoles}
          isMaxRolesCountReached={isMaxRolesCountReached}
        />
      </AddRoleWrapper>
      <Roles
        roles={allRoles}
        isMaxRolesCountReached={isMaxRolesCountReached}
        permissions={allPermissions}
      />
    </>
  );
};

export default RolesManagement;
